export const STANDALONE_NO_AUDIO = 'SA-'
export const STANDALONE_AUDIO = 'SA+'
export const NIKKEI_DISABLED = 'P-'
export const NIKKEI_ENABLED = 'P+'

export const AUDIO_ENGINE_STATE = {
  NO_SUSHI: 0,
  STANDALONE_AUDIO: 1,
  NIKKEI_ENABLED: 2
}